import React, { Component } from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';
import swal from 'sweetalert';

import $ from 'jquery';

import {callerActionHistoryInchreaseCalledTimes, callerActionHistoryListCalled, callerConfiguration, callerConfigurationInitStatus, healthFacilitiesId} from '../../libs/services';
import { Table } from 'react-bootstrap';
import sound from '../../assets/sounds/caller.mp3';
window.$ = window.jQuery = require("jquery");
require('ms-signalr-client');

var Config = require('../../config');
var _hub;
var ChatProxy;
var ChatUrl = Config.default.apiGateway.short_url + "signalr";
var CallerSocket = null;
var message = null;

let mySound = new Audio(sound)

class CallerList extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.increaseCalledTimes = this.increaseCalledTimes.bind(this);

		this.state = {
			list_called: [],
			health_facilities_name:"",
			section:""
		}
	}

	async componentWillMount(){
		this._mounted = true;
		var search = this.props.match.url.replace('/', '');        

		//Actualizar listado por mensaje del servidor
      	_hub = $.hubConnection(ChatUrl, {
        	useDefaultPath: false
      	});

      	ChatProxy = _hub.createHubProxy('ChatHub');
      	ChatProxy.getItems = this.getList;

      	ChatProxy.on("addNewMessageToPage", function(name, message) {
	        if(message === "refresh" && search.indexOf('caller_list') !== -1){
	            this.getItems();
	        }
      	});

      	_hub.start()
      	.done(function() {
        	console.log("Connected to Signalr Server");
      	})
      	.fail(function() {
        	console.log("failed in connecting to the signalr server");
      	});
      	
		this.creaSocket();

		var response = await healthFacilitiesId(this.props.match.params.health_id, this.props.waiting);
		if(response !== undefined){
			this.setState({
				health_facilities_name: response.health_facilities.name
			});
		}

		response = await callerConfigurationInitStatus(this.props.match.params.health_id);
		if(response){
			this.setState({section:response});
		}

        await this.getList();
	}

	creaSocket(){
		CallerSocket = null;
		message = null;

		try{
			CallerSocket = new WebSocket('ws://localhost:2019/');
			console.log('socket llamador creado');
			this.socketActions();
		}catch(error){
			console.log('error socket');
			console.log(error);
		}
	}

	socketActions(){
		if(CallerSocket){
			CallerSocket.onopen = function(event){
				CallerSocket.send('Init');
				console.log('abriendo caller socket')
				if(message){
					CallerSocket.send(message);	
					message = null;
				}
			};

			CallerSocket.onmessage = function(event){
				var res = JSON.parse(event.data);
				
				console.log(JSON.stringify(res));
				if(res.Error){
					console.log(res.Error);
					return;
				}

				if(res.Mensaje){
					console.log(res.Mensaje);
					return
				}
			}
		}
	}

	enviaMensaje(mensaje){
		if(CallerSocket === null || (CallerSocket !== null && CallerSocket.readyState === WebSocket.CLOSED)){
			this.creaSocket();
		}

		if(CallerSocket){
			if(CallerSocket.readyState === WebSocket.CONNECTING){
				message = mensaje;
				return;
			}
			CallerSocket.send(mensaje)
		}else{
			swal('Error', "No fue posible conectar con aplicación HAP", 'error');
		}
	}

	componentWillUnmount(){
		this._mounted = false;
		CallerSocket.close();
		console.log('Cerrando socket')
	}

	async getList(){
		var response = await callerActionHistoryListCalled(this.props.match.params.health_id);
		if(response !== undefined){
			if(this._mounted){				
				this.setState({list_called:response});
				if(response.length > 0){
					setTimeout(function(){//reproducir sonido
						try{
														
							if(response[0].machine_name !== null && response[0].machine_name !== 'NULL' && response[0].called_times === 0 && response[0].section !== this.state.section){
								this.enviaMensaje("Ficha numero "+response[0].record_number+", pasar a "+response[0].machine_name.split('|')[0]);
                                this.increaseCalledTimes(response[0].id);
                                
							}
						}catch{
							swal('Error', "No fue posible conectar con aplicación HAP", 'error');
						}
					}.bind(this), 500);
				}
			}
		}		
	}

	async increaseCalledTimes(caller_id, machine_name){
		await callerActionHistoryInchreaseCalledTimes(caller_id);
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12 form-group">
				<fieldset>
					<legend style={{textAlign:"center"}}>
						<h2>{this.state.health_facilities_name}</h2>
					</legend>
					<div className="col-xs-12">
                        <Table responsive hover className="llamador">
                            <thead>
                                <tr>
                                    <th>{t('content.list_called.table.caller_number')}</th>
                                    <th>Hora Registro</th>
                                    <th>{t('content.list_called.table.attendant')}</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.list_called.map((l, i)=>(
                                    <tr key={i} className={i===0 ? "llamado" : "registrado"}>
                                        <td>{l.record_number}</td>
                                        <td>{moment(l.called_timestamp).format('HH:mm')}</td>                                        
                                        <td>
                                            {l.section}
                                            {l.machine_name !== null && l.machine_name !== 'NULL' ? ' | '+l.machine_name.split('|')[0] : ''}
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </Table>
                    </div>
				</fieldset>
			</div>
		)
	}
}

export default translate('translations')(CallerList);